import axios from 'axios';

import { handleApiSucess, handleApiError, getRequestHeaders } from 'api/util.api';
import { handleRequest } from './util.api';

// const getUploadUrl = (company,subcompany) => "/upload_file";

const getUploadUrl = (cId, sId) => `/companies/${cId}/subcompanies/${sId}/upload_file`;

const service = {
  configure(endpoint = '', auth = {}, defaultHeaders = {}) {
    this.endpoint = endpoint;
    this.auth = auth;
    this.defaultHeaders = defaultHeaders;
    this.getHeaders = getRequestHeaders(this.auth, this.defaultHeaders);

    this.axios = axios.create({
      baseURL: this.endpoint,
      timeout: 30000,
    });

    this.axios.interceptors.request.use((request) => {
      handleRequest(request);
      return request;
    });

    return this;
  },

  upload(file, onProgress = null, cId, sId) {
    const url = getUploadUrl(cId, sId);
    var data = new FormData();
    data.append('file', file);
    return this.axios
      .post(url, data, {
        // getHeaders is a function (util.api.js getRequestHeaders): spreading it
        // without calling it sent no x-auth-token. Its Content-Type: application/json
        // is harmless here: axios drops Content-Type for FormData so the browser
        // sets the multipart boundary (axios/lib/adapters/xhr.js), as in putBill.
        ...this.getHeaders(),
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          onProgress && onProgress(percentCompleted);
        },
      })
      .then(handleApiSucess)
      .catch(handleApiError);
  },
};

export default service;



// WEBPACK FOOTER //
// src/lib/api/uploads.api.js